import { Fragment, useRef } from 'react'

import { clsx } from 'clsx'

import { BreadcrumbEllipsis, BreadcrumbItem } from './BreadcrumbsItems'
import { useBreadcrumbsVisibility } from '~/hooks/useBreadcrumbsVisibility'

export interface Breadcrumb {
  title: string
  id: string
}

export const BreadcrumbBar = ({ data }: { data: Breadcrumb[] }) => {

  const containerRef = useRef(null) as unknown as React.RefObject<HTMLDivElement>

  const { showEllipsis, visibilityData, firstAndLastExceedSpace } = useBreadcrumbsVisibility(data, containerRef)

  if (data.length <= 1) {
    return null
  }

  return (
    <div ref={containerRef}
      className={clsx(
        'h-[20px] relative left-0 block w-full max-w-full mb-1',
        'overflow-hidden'
      )}
      data-testid="breadcrumb-wrapper"
    >
      <div className="flex whitespace-nowrap" data-testid="breadcrumb">
        {firstAndLastExceedSpace ?
          <ol className="flex w-full">
            <BreadcrumbItem
              title={data[0].title}
              id={data[0].id}
              renderEllipsis={true}
            />

            {showEllipsis ? <BreadcrumbEllipsis /> : null as any}
            <BreadcrumbItem
              title={data[data.length - 1].title}
              id={data[data.length - 1].id}
              renderEllipsis={true}
              isLastItem={true}
            />
          </ol>
          :
          <ol className="flex">
            {data.map((item, i) => (
              <Fragment key={item.id}>
                {showEllipsis && i === 1 ? <BreadcrumbEllipsis /> : null as any}
                <BreadcrumbItem
                  title={item.title}
                  id={item.id}
                  className={clsx(
                    (visibilityData.find(el => el.id === item.id)?.hidden && i !== 0) && 'hidden')}
                />
              </Fragment>))}
          </ol>
        }
      </div>
    </div >

  )
}